/** Fresh per attempt so each retry is independently traceable. */
export function createRequestId(): string {
  return crypto.randomUUID();
}
